import { useContext } from 'react'
import { Badge, Button } from 'antd'

import { AppContext } from '../context/AppContext'
import { getCommunities, SERVER } from '../network/API'

import PageWrap from '../components/layout/PageWrap'
import TableBlock from '../components/tables/TableBlock'
import DynamicStrings from '../components/DynamicStrings'

const Communities = ({ history }) => (
    <PageWrap title="MENU_COMMUNITIES">
        <TableBlock
            columns={columns}
            filters={filters}
            name="getCommunities"
            request={getCommunities}
            pageSize={80}
            className="communities-table"
            tableLayout="fixed"
            onRow={(record) => ({
                onClick: () => history.push(`/communities/${record.id}`),
                style: { cursor: 'pointer' },
            })}
        />
    </PageWrap>
)

const filters = (history) => ({
    fields: [
        {
            type: 'text',
            label: 'COMMUNITIES_NAME',
            key: 'name',
        },
    ],
    actions: [
        {
            label: 'COMMUNITIES_CREATE',
            component: () => <BtnCreate history={history} />,
        },
    ],
})

const BtnCreate = ({ history }) => {
    const { user } = useContext(AppContext)

    if (user.role !== 'super-admin' && user.role !== 'admin') {
        return null
    }

    return (
        <Button type="primary" onClick={() => history.push('/communities/create')}>
            <DynamicStrings id="COMMUNITIES_CREATE" />
        </Button>
    )
}

const columns = () => [
    {
        title: <DynamicStrings id="COMMUNITIES_NAME" />,
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        render: (name) => (
            <span className="communities-list-name">{name}</span>
        ),
    },
    {
        title: <DynamicStrings id="COMMUNITIES_ICON" />,
        dataIndex: 'icon',
        key: 'icon',
        width: 140,
        render: (icon) =>
            icon?.uri ? (
                <img
                    className="communities-list-icon"
                    src={`${SERVER.baseURL}/storage/communities/${icon.uri}`}
                    alt=""
                />
            ) : null,
    },
    {
        title: <DynamicStrings id="COMMUNITIES_STATUS" />,
        dataIndex: 'status',
        key: 'status',
        width: 160,
        sorter: true,
        render: (status) => {
            const config = {
                publish: {
                    color: 'success',
                    text: 'COMMUNITIES_STATUS_PUBLISH',
                },
                not_publish: {
                    color: 'default',
                    text: 'COMMUNITIES_STATUS_NOT_PUBLISH',
                },
            }

            const item = config[status]

            return (
                <Badge
                    status={item?.color || 'default'}
                    text={
                        <DynamicStrings
                            id={item?.text || 'COMMUNITIES_STATUS_NOT_PUBLISH'}
                        />
                    }
                />
            )
        },
    },
]

export default Communities
